export var CustomerPortalVisibilityPermissionsVoData;
(function (CustomerPortalVisibilityPermissionsVoData) {
    CustomerPortalVisibilityPermissionsVoData["NONE"] = "NONE";
    CustomerPortalVisibilityPermissionsVoData["ALL_PUBLISHED_FEEDBACK"] = "ALL_PUBLISHED_FEEDBACK";
    CustomerPortalVisibilityPermissionsVoData["ACCOUNT_LEVEL_FEEDBACK"] = "ACCOUNT_LEVEL_FEEDBACK";
    CustomerPortalVisibilityPermissionsVoData["OWN_FEEDBACK"] = "OWN_FEEDBACK";
    CustomerPortalVisibilityPermissionsVoData["SPECIFIED_ITEM_TYPES"] = "SPECIFIED_ITEM_TYPES";
})(CustomerPortalVisibilityPermissionsVoData || (CustomerPortalVisibilityPermissionsVoData = {}));
//# sourceMappingURL=customer-portal-visibility-permissions-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/customer-apps/customer-portal/customer-portal-visibility-permissions-vo-data.js
// module id = 931
// module chunks = 14